import lazyLoadOnRender from '../../lazy/loadOnRender';

const MediaLightboxErrorBoundary = () =>
  import(/* webpackChunkName: "4-feat-medialightbox" */ './MediaLightboxErrorBoundary');

export default lazyLoadOnRender({ loader: MediaLightboxErrorBoundary });
